import Button from './Button'
import Icon from '../Icon'
import FileInput from '../FileInput'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

export default class FileUploadButton extends PureComponent {
  static propTypes = {
    disabled: PropTypes.bool,
    label: PropTypes.string,
    url: PropTypes.string.isRequired
  }

  static defaultProps = {
    disabled: false,
    label: 'Upload'
  }

  render() {
    const { label, ...fileProps } = this.props

    return (
      <Button
        role="create"
        className="qv-button-upload"
        preventDefault={false}
        disabled={this.props.disabled}
      >
        <Icon name="upload" />
        <span>{' ' + I18n.t(label)}</span>
        <FileInput {...fileProps} />
      </Button>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/buttons/FileUploadButton.js